import { createBrowserRouter } from "react-router-dom";
import { googleGAKey, isDevelopment } from "./environment";
import ReactGA from "react-ga4";
import axios from "axios";
import { captureClickIdsFromSearch, getPersistedClickId } from "./clickIds";

export const analyticsSetup = () => {
  if (isDevelopment) return;

  ReactGA.initialize(googleGAKey, {
    gaOptions: {
      allowLinker: true,
      cookieDomain: "auto",
    },
  });
};

export const getCreateRouter = () => {
  return createBrowserRouter;
};

export const getGclid = (): string | null => {
  captureClickIdsFromSearch();
  const persisted = getPersistedClickId("gclid");
  if (persisted) return persisted;

  const urlParams = new URLSearchParams(window.location.search);
  const gclidFromUrl = urlParams.get("gclid");
  if (gclidFromUrl) return gclidFromUrl;

  return null;
};
